import http from '../../utils/fetch';
export default {
    baseurl:'/api/swyl/v1/xxxx/xxxx',
    baseurl2:'/api',
    //--------------------------msgFunnel  网络对阵--------------------
    selectPage(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/selectOrderForecastPage',
            method: 'post',
            params: query
        });
    },
    deleteGradOrder(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/deleteQuarterlyGrabOrder',
            method: 'post',
            data: query
        });
    },
    //批量删除
    deleteBatch(query){
        return http({
            url: '/api/swyl/v1/grabOrderCustomer/deleteBatch',
            method: 'post',
            data: query
        });
    },
    // 抢单 客户
    selectPageCustom(query){
        return http({
            url: '/monthly/order/monthly/signing/list',
            method: 'get',
            params: query
        });
    },

    //获取动态表头信息
    getMonthList(query){
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/selectMonthByQuarterly?quarterly='+query,
            method: 'post',
            params: query
        });
    },
    //批量导出
    downloadBatchExcel(query) {
        return http({
            url: '/api/swyl/v1/quarterlyGrabOrder/downloadExcel',
            method: 'post',
            data: query,
            responseType: 'blob',
        });
    },
    //--------------------------msgFunnel  目标对阵用户--------------------
    selectPageTargetAgainstUser(query){
        return http({
            url: '/api/swyl/v1/bscTargetAgainstUser/selectPage',
            method: 'post',
            params: query
        });
    },
    deleteTargetAgainstUser(query){
        return http({
            url: '/api/swyl/v1/bscTargetAgainstUser/delete',
            method: 'post',
            data: query
        });
    },
    //目标对阵用户单条增加
    insertbattle(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTargetAgainstUser/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    //根据instid查询删除数据
    getListByInstid(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTargetAgainstUser/getListByInstid',
            method: 'post',
            data: query
        });
    },
    //根据instid查询删除数据
    delPass(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTargetAgainstUser/delPass',
            method: 'post',
            data: query
        });
    },
     //根据instid查询删除数据
     updateAndAddPass(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTargetAgainstUser/addPassAndUpdate',
            method: 'post',
            data: query
        });
    },
    getChongFuCustomerName() {
        return http({
            url: this.baseurl2 + '/swyl/v1/bscTargetAgainstUser/getChongFuCustomerName',
            method: 'post',
        });
    },
    //查询分销商2.0对阵用户
    getDistributor2toUser(userCode,deptName){
        return http({
            url: '/api/swyl/v1/bscTargetAgainstUser/getDistributor2toUser?userCode='+userCode+'&deptName='+deptName,
            method: 'post',
        });
    },

//-------------------------------TOP用户管理-------------------------------------
//TOP用户管理查询
selectPageTopManagementUser(query){
    return http({
        url: '/api/swyl/v1/bscTopManagementUser/selectPage',
        method: 'post',
        params: query
    });
},

    //TOP用户管理查询
    selectgTopSalseQuotaPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopUserForm/selectPage',
            method: 'post',
            params: query
        });
    },

    //TOP用户管理查询跑动
    selectSignContentPage(query){
        return http({
            url: '/api/swyl/v1/bscTopManagementUser/selectSignContentPage',
            method: 'post',
            params: query
        });
    },

    //TOP用户管理查询漏斗
    selectLoudMainList(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopUserForm/selectLoudMainListPage',
            method: 'post',
            params: query
        });
    },
    //TOP用户管理查询招标
    selectBidList(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopUserForm/selectBidListPage',
            method: 'post',
            params: query
        });
    },
    //TOP用户管理查询关差
    selectDiffListPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopUserForm/selectDiffListPage',
            method: 'post',
            params: query
        });
    },
    //TOP用户管理查询竞品
    selectCompetitorsListPage(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopUserForm/selectCompetitorsListPage',
            method: 'post',
            params: query
        });
    },

    //Top用户管理单条增加
    insertTopManagement(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTopManagementUser/saveOrUpdate',
            method: 'post',
            data: query
        });
    },
    //Top用户管理删除多条
    deleteTopManagementUser(query){
        return http({
            url: '/api/swyl/v1/bscTopManagementUser/deleteById',
            method: 'post',
            data: query
        });
    },
    //Top用户管理查询删除数据
    updateAnddelTopProcess(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTopManagementUser/updateAnddelTopProcess',
            method: 'post',
            data: query
        });
    },
    //ToP用户管理修改数据
    saveOrUpdateTop(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTopManagementUser/saveOrUpdate',
            method: 'post',
            data: query
        });
    },


    //TOP用户管理查询
    selectgTopTendersMessagePage(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopTendersMessage/selectPage',
            method: 'post',
            params: query
        });
    },
    //ToP用户管理修改数据
    saveOrUpdateTopManagementUser(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopTendersMessage/saveOrUpdate',
            method: 'post',
            data: query
        });
    },

    //ToP用户管理修改数据
    selectByIdTopManagementUser(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopTendersMessage/selectById?id='+query,
            method: 'post',
        });
    },
    //TOP用户管理查询
    deletebatchById(query){
        return http({
            url: '/api/swyl/v1/demo/bscTopTendersMessage/deletebatchById',
            method: 'post',
            data: query
        });
    },


    //-------------------------------------------------------------------
        //top用户查看修改记录

    queryTopRecord(query){
        return http({
            url: this.baseurl2+'/swyl/v1/bscTopManagementUserRecord/selectListPage',
            method: 'post',
            data: query
        });
    },



    //-------------------------- 市场行情信息反馈汇总--------------------
    selectPageUserMarketConditions(query){
        return http({
            url: '/api/swyl/v1/demo/userMarketConditions/selectListPage',
            method: 'post',
            params: query
        });
    },

    deleteUserMarketConditions(query){
        return http({
            url: '/api/swyl/v1/demo/userMarketConditions/delete',
            method: 'post',
            data: query
        });
    },
    //-------------------------- 资源需求信息汇总--------------------

    selectPageUserResourceNeedMessage(query){
        return http({
            url: '/api/swyl/v1/demo/userResourceNeedMessage/selectListPage',
            method: 'post',
            params: query
        });
    },

    deleteUserResourceNeedMessage(query){
        return http({
            url: '/api/swyl/v1/demo/userResourceNeedMessage/delete',
            method: 'post',
            data: query
        });
    },
    //--------------------------窜货申请--------------------


    selectAppealPage(query){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/selectPage',
            method: 'post',
            params: query
        });
    },

    orderAppealAdd(query){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/orderAppealAdd',
            method: 'post',
            params: query
        });
    },
    selectByUserNameAppela(query){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/selectByUserNameAppela?customerName='+ query,
            method: 'post',
            //params: query
        });
    },
    selectByInstidAppela(instid){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/selectByInstidAppela?instid='+ instid,
            method: 'post',
            //params: query
        });
    },
    orderAppealPass(query){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/orderAppealPass',
            method: 'post',
            params: query
        });
    },
    getTaskById(taskId){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/getTaskById?taskId='+ taskId,
            method: 'post',
            //params: query
        });
    },
    deleteByModel(query){
        return http({
            url: '/api/swyl/v1/appeal/bscOrderAppeal/deleteByModel',
            method: 'post',
            params: query
        });
    },
    //--------------------------窜货申请--------------------

}
